// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog-module__dialog--MhFCE","fullScreen":"Dialog-module__fullScreen--Q9wVl","closeButton":"Dialog-module__closeButton--ArexS"};